(function () {
    if (window.__activeCampaignTrackingInit) {
        return;
    }
    window.__activeCampaignTrackingInit = true;

    const TRACKED_PAGE_TYPES = ['service', 'hr_topic', 'hr_challenge', 'contact'];
    const firedEvents = {};

    function parseJsonScript(id) {
        const el = document.getElementById(id);
        if (!el) {
            return null;
        }
        try {
            return JSON.parse(el.textContent || '{}');
        } catch (error) {
            return null;
        }
    }

    function postEvent(name, payload) {
        const config = parseJsonScript('acEventConfig');
        if (!config || !config.actid || !config.key) {
            return false;
        }

        const body = new URLSearchParams();
        body.set('actid', config.actid);
        body.set('key', config.key);
        body.set('event', name);
        body.set('eventdata', JSON.stringify(payload || {}));
        body.set('visit', JSON.stringify({ email: config.email || '' }));

        try {
            fetch('https://trackcmp.net/event', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body.toString(),
                keepalive: true,
            }).catch(function () {
                // ignore tracking errors
            });
            return true;
        } catch (error) {
            return false;
        }
    }

    function trackEvent(name, payload, dedupeKey) {
        if (dedupeKey && firedEvents[dedupeKey]) {
            return;
        }
        if (dedupeKey) {
            firedEvents[dedupeKey] = true;
        }

        postEvent(name, payload || {});
    }

    function trackPageVisit() {
        const ctx = parseJsonScript('acPageContext');
        if (!ctx || !ctx.pageType || TRACKED_PAGE_TYPES.indexOf(ctx.pageType) === -1) {
            return;
        }

        trackEvent('Page Visit', {
            page_type: ctx.pageType,
            page_title: ctx.pageTitle || '',
            url: ctx.pageUrl || window.location.href,
        }, 'page:' + ctx.pageType + ':' + (ctx.pageUrl || window.location.pathname));
    }

    function resourcePayloadFromContext(ctx) {
        return {
            resource_id: String(ctx.resource_id || ''),
            resource_name: ctx.resource_name || '',
            resource_category: ctx.resource_category || '',
            resource_type: ctx.resource_type || '',
            resource_url: ctx.resource_url || window.location.href,
        };
    }

    function trackResourceViewed() {
        const ctx = parseJsonScript('acResourceContext');
        if (!ctx || !ctx.resource_id) {
            return;
        }

        trackEvent(
            'Resource Viewed',
            resourcePayloadFromContext(ctx),
            'view:' + ctx.resource_id
        );
    }

    function trackResourceWatched(ctx) {
        if (!ctx || !ctx.resource_id) {
            return;
        }

        trackEvent(
            'Resource Watched',
            resourcePayloadFromContext(ctx),
            'watch:' + ctx.resource_id
        );
    }

    function bindResourceDownloadTracking() {
        document.addEventListener('click', function (event) {
            const downloadLink = event.target.closest('.resource-detail__download-link');
            if (downloadLink) {
                const ctx = parseJsonScript('acResourceContext');
                if (!ctx) {
                    return;
                }
                trackEvent(
                    'Resource Downloaded',
                    resourcePayloadFromContext(ctx),
                    'download:' + ctx.resource_id
                );
                return;
            }

            const watchLink = event.target.closest('.resource-detail__watch-link');
            if (!watchLink) {
                return;
            }

            const ctx = parseJsonScript('acResourceContext');
            if (!ctx) {
                return;
            }
            trackResourceWatched(ctx);
        }, true);
    }

    function ensureYoutubeIframeApi(callback) {
        if (window.YT && window.YT.Player) {
            callback();
            return;
        }

        const previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
            if (typeof previous === 'function') {
                previous();
            }
            callback();
        };

        if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
    }

    function bindResourceYoutubeWatchTracking() {
        const iframes = document.querySelectorAll(
            '.resource-detail iframe[data-ac-track-watch="1"]'
        );
        if (!iframes.length) {
            return;
        }

        const ctx = parseJsonScript('acResourceContext');
        if (!ctx || !ctx.resource_id) {
            return;
        }

        ensureYoutubeIframeApi(function () {
            iframes.forEach(function (iframe, index) {
                if (!iframe.id) {
                    iframe.id = 'ac-resource-yt-' + ctx.resource_id + '-' + index;
                }

                try {
                    // eslint-disable-next-line no-new
                    new window.YT.Player(iframe.id, {
                        events: {
                            onStateChange: function (event) {
                                if (event.data === window.YT.PlayerState.PLAYING) {
                                    trackResourceWatched(ctx);
                                }
                            },
                        },
                    });
                } catch (error) {
                    // ignore player init errors
                }
            });
        });
    }

    trackPageVisit();
    trackResourceViewed();
    bindResourceDownloadTracking();
    bindResourceYoutubeWatchTracking();

    window.ActiveCampaignTracking = {
        trackEvent: trackEvent,
    };
}());
